import { executeRefresh } from '~/composables/useAuthRefresh'

/**
 * リロード時、nuxt-auth の getSession が失効済み access token で 401 になると
 * status が unauthenticated になり、global middleware → /auth/init → 卸画面へ
 * 飛ばされる。refresh token が残っている場合はここで復帰させる。
 *
 * API 呼び出し中の 401 は useAuthedFetch が担う。ここは getSession 経路専用。
 * enforce: 'post' で nuxt-auth plugin の初回 getSession の後に実行する。
 */
export default defineNuxtPlugin({
  name: 'auth-session-refresh',
  enforce: 'post',
  async setup() {
    const route = useRoute()
    // handoff は signIn が新規トークンを取るため、stale refresh で先回りしない
    if (route.path.startsWith('/auth/init')) {
      return
    }

    const { status, getSession } = useAuth()
    const { rawRefreshToken } = useAuthState()

    if (status.value !== 'unauthenticated' || !rawRefreshToken.value) {
      return
    }

    const refreshed = await executeRefresh()
    if (refreshed) {
      await getSession({ force: true })
    }
  },
})
